// Service for the Attendance Dashboard "Mi equipo" — "Situación de asistencia" section,
// "Marcajes" card (ASIS-5407 / REXASIS-006).
// GET /attendance/my-team/today/marks-summary?companyIds=1,2&employeeIds=10,15 —
// both query params are optional CSV lists; omitted/[] means "Todos" (no filter),
// scoped to the Empresa/Colaborador filters of the "Mi equipo" dashboard.

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetTodayMarksSummaryOut,
  GetMyTeamMarksSummaryParams,
  MyTeamMarksSummary,
} from '../types/myTeamMarksSummary.types';
import { mapMyTeamMarksSummary } from '../mappers/myTeamMarksSummary.mapper';


export class MyTeamMarksSummaryService {
  async getSummary(
    params?: GetMyTeamMarksSummaryParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamMarksSummary>> {
    const query = buildQueryString({
      companyIds: params?.companyIds?.map(String),
      employeeIds: params?.employeeIds?.map(String),
    });
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE_MY_TEAM_TODAY_MARKS_SUMMARY}${query}`;
    const response = await apiClient.get<LC_GetTodayMarksSummaryOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamMarksSummary(response.data) };
  }
}

export const myTeamMarksSummaryService = new MyTeamMarksSummaryService();
